module.exports = __webpack_public_path__ + "static/images/card-img.2503aba.png";